import queryString from 'query-string';
import type { NskResponse } from '~/models/Api';
import {
  deleteRequest,
  postRequest,
  putRequest
} from '~/utils/api/api_handler';
import type {
  DealConstruction,
  DealConstructionEdit
} from '~/models/DealConstruction';
import { generatePath } from '~/utils/generatePath';
import { convertDealConstructionToPayload } from '~/utils/api/convertDealConstructionPayload';

export const create = async (
  dealEstimation: DealConstructionEdit,
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(
    queryString.stringifyUrl({
      url: generatePath('/deals/:deal_id/deal_own_estimations', {
        deal_id: dealId
      })
    }),
    {
      dealEstimation: convertDealConstructionToPayload(dealEstimation)
    }
  );

export const update = async (
  dealEstimation: DealConstructionEdit,
  dealEstimationId: number,
  dealId: number
): Promise<NskResponse<void>> =>
  putRequest(
    queryString.stringifyUrl({
      url: generatePath('/deals/:deal_id/deal_own_estimations/:id', {
        deal_id: dealId,
        id: dealEstimationId
      })
    }),
    { dealEstimation: convertDealConstructionToPayload(dealEstimation) }
  );

export const destroy = async (
  dealEstimationId: number,
  dealId: number
): Promise<NskResponse<void>> =>
  deleteRequest(
    generatePath('/deals/:deal_id/deal_own_estimations/:id', {
      deal_id: dealId,
      id: dealEstimationId
    })
  );

export const updateSeq = async (
  dealEstimations: DealConstruction[],
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(
    generatePath('/deals/:deal_id/deal_own_estimations/update_seq', {
      deal_id: dealId
    }),
    { dealEstimations }
  );
